import router from '@/router'

export interface MenuListItem {
  name: string
  routeUrl: string
  localKey?: string
}
const tablist: MenuListItem[] =
  window.sessionStorage.getItem('tablist') &&
  JSON.parse(window.sessionStorage.getItem('tablist') as any)
const currentTab =
  window.sessionStorage.getItem('currentTab') &&
  JSON.parse(window.sessionStorage.getItem('currentTab') as any)
const menulist: any[] =
  window.localStorage.getItem('menulist') &&
  JSON.parse(window.localStorage.getItem('menulist') as any)
const pagelist: any[] =
  window.localStorage.getItem('pagelist') &&
  JSON.parse(window.localStorage.getItem('pagelist') as any)
const recentVisitList: any[] =
  window.localStorage.getItem('recentVisitList') &&
  JSON.parse(window.localStorage.getItem('recentVisitList') as any)
interface State {
  visible: boolean
  currentMenu: string
  menuList: any[]
  pageList: MenuListItem[]
  tabList: MenuListItem[]
  currentTab: MenuListItem | null
  microApps?: any[]
  recentVisitList: any
  backRoute: any
  menuLoading?: boolean
}

const state: State = {
  visible: false,
  currentMenu: '',
  menuList: menulist || [],
  pageList: pagelist || [],
  tabList: tablist || [],
  currentTab: currentTab || null,
  recentVisitList: recentVisitList || [],
  backRoute: null,
  menuLoading: false
}

const getters = {
  /** 从 pageList 遍历出的权限编码集合 */
  getPermissionSet(state: State): Set<string> {
    const set = new Set<string>()
    const pageList = state.pageList || []
    pageList.forEach((item: any) => {
      if (item.permissionCode) {
        set.add(item.permissionCode)
      }
      const buttonList = item.buttonList || []
      buttonList.forEach((btn: any) => {
        if (btn.permissionCode) {
          set.add(btn.permissionCode)
        }
      })
    })
    return set
  }
}

const mutations = {
  changeVisible(state: State, visible: boolean) {
    state.visible = visible
  },
  changeCurrentMenu(state: State, path: string) {
    state.currentMenu = path
  },
  setMenuList(state: State, menuList: any[]) {
    // state.menuList = []
    // window.localStorage.setItem('menulist', '[]')
    state.menuList = menuList
    window.localStorage.setItem('menulist', JSON.stringify(state.menuList))
  },
  setPageList(state: State, pageList: any[]) {
    // state.pageList = []
    // window.localStorage.setItem('pagelist', '[]')
    state.pageList = pageList
    window.localStorage.setItem('pagelist', JSON.stringify(state.pageList))
  },
  addTabMenu(state: State, item: MenuListItem): void {
    state.tabList.unshift(item)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  changeTabMenu(state: State, indexObj: any) {
    if (indexObj.draggedIndex !== indexObj.index) {
      // 如果拖拽的目标和放置的目标不一致
      const temp = state.tabList[indexObj.draggedIndex] // 临时保存拖拽的标签页数据
      state.tabList.splice(indexObj.draggedIndex, 1) // 移除原位置的标签页数据
      state.tabList.splice(indexObj.index, 0, temp) // 在放置的位置插入拖拽的标签页数据
    }
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
  },
  setCurrentTab(state: State, item: MenuListItem): void {
    state.currentTab = item
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  changeCurrentTab(state: State, item: MenuListItem): void {
    state.currentTab = item
    const tabIndex = state.tabList.findIndex(
      tab => tab.name === item.name || tab.routeUrl.split('?')[0] === item.routeUrl.split('?')[0]
    )
    tabIndex !== -1 && state.tabList.splice(tabIndex, 1, item)
    window.sessionStorage.setItem('currentTab', JSON.stringify(state.currentTab))
    ;(this as any).commit('microApp/updateMicroCacheList')

    // 添加最近访问
    const currentRouteIndex = state.recentVisitList.findIndex(
      (route: any) => route.routeUrl?.split('?')[0] === item.routeUrl?.split('?')[0]
    )
    if (currentRouteIndex > -1) {
      state.recentVisitList.splice(currentRouteIndex, 1)
    }
    state.recentVisitList.unshift(item)
    state.recentVisitList.splice(8)
    window.localStorage.setItem('recentVisitList', JSON.stringify(state.recentVisitList))
  },
  deleteTab(state: State, name: string, auto = false): void {
    const index = state.tabList.findIndex(item => item.name === name)
    state.tabList.splice(index, 1)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  defaultDeleteTab(state: State, name: string): void {
    const index = state.tabList.findIndex(item => item.name === name)

    let nextTabIndex = index + 1
    if (nextTabIndex === state.tabList.length) nextTabIndex = index - 1
    const nextTab = state.tabList[nextTabIndex]
    mutations.changeCurrentTab(state, nextTab)

    router.push(nextTab.routeUrl)

    state.tabList.splice(index, 1)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  resetTab(state: State) {
    window.sessionStorage.removeItem('tablist')
    window.sessionStorage.removeItem('currentTab')
    state.tabList = []
    state.currentTab = null
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  setTab(state: State, items: MenuListItem[]) {
    state.tabList = items
    console.log(items)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  setErrorLastRoute(state: State, route: any) {
    state.backRoute = route
  },
  changeMenuLoading(state: State, visible: boolean) {
    state.menuLoading = visible
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
